export default __webpack_public_path__ + "assets/f9M2o.jpg";